import { graphql, readInlineData } from 'react-relay';
import { type isFilterValueApplied_itemSearch$key } from './__generated__/isFilterValueApplied_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment isFilterValueApplied_itemSearch on ItemSearchQueryConnection @inline {
        appliedFilters {
            name
            values {
                urlLabel
            }
        }
    }
`;

export const isFilterValueApplied = ({
    itemSearch: itemSearchRef,
    filterName,
    urlLabel,
}: {
    itemSearch: isFilterValueApplied_itemSearch$key;
    filterName: string;
    urlLabel: string;
}): boolean => {
    const itemSearch = readInlineData(itemSearchFragment, itemSearchRef);
    return (itemSearch.appliedFilters || []).some(
        f => f?.name === filterName && (f?.values || []).some(v => v?.urlLabel === urlLabel)
    );
};
